export { default } from './SmartboardGallery';



// WEBPACK FOOTER //
// ./src/components/SmartboardGallery/index.js